const EnumLectureState = Object.freeze({
  CREATED: "CREATED",
  STARTED: "STARTED",
  ENDED: "ENDED",
});

export default EnumLectureState;
